var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from 'classnames';
import omit from 'lodash/omit';
import React from 'react';
import { ListItem as EDSListItem } from '@hedtech/react-design-system/core/es/List';
import { createStyles, withStyles } from '../styles/withStyles';
const styles = createStyles({
    noButton: {
        cursor: 'default'
    },
    root: {}
});
const ListItem = (props) => {
    const { button, children, classes } = props, rest = __rest(props, ["button", "children", "classes"]);
    const classOverrides = omit(classes, ['noButton']);
    if (!Boolean(button)) {
        classOverrides.root = classnames(classes.root, classes.noButton);
    }
    return (React.createElement(EDSListItem, Object.assign({ button: button, classes: classOverrides }, rest), children));
};
export default withStyles(styles)(ListItem);
